import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../../../Translations';
import { formatDate } from '../../dates';
import { ConnectionResource, vendorName } from '../../Types';
import DeleteConnection from '../DeleteConnection';

interface Props {
  resource: ConnectionResource;
}

const DetailsCard: React.FC<Props> = ({ resource }) => (
  <div>
    <h3 className="text-base font-semibold text-foreground">
      <T kind="Connection details" />
    </h3>
    <div className="mt-3 rounded-lg border border-border bg-card p-6">
      <dl className="m-0 grid grid-cols-[10rem_1fr] gap-x-4 gap-y-3 text-sm">
        <dt className="text-muted-foreground">
          <T kind="Provider" />
        </dt>
        <dd className="m-0 text-foreground">
          <T kind={vendorName(resource.payload.vendor)} />
        </dd>
        <dt className="text-muted-foreground">
          <T kind="Connection ID" />
        </dt>
        <dd className="m-0 break-all font-mono text-xs text-foreground">
          {resource.payload.providerName}
        </dd>
        <dt className="text-muted-foreground">
          <T kind="Environment" />
        </dt>
        <dd className="m-0 text-foreground">
          {resource.payload.environment === 'production' ? (
            <T kind="Production" />
          ) : (
            <T kind="Staging / test" />
          )}
        </dd>
        <dt className="text-muted-foreground">
          <T kind="Created" />
        </dt>
        <dd className="m-0 text-foreground">{formatDate(resource.payload.createdAt)}</dd>
        <dt className="text-muted-foreground">
          <T kind="Domains" />
        </dt>
        <dd className="m-0 text-foreground">
          <T kind="None assigned yet" />
        </dd>
      </dl>
      <hr className="my-4 border-border" />
      <DeleteConnection resource={resource} />
    </div>
  </div>
);

export default observer(DetailsCard);
